import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TextField, Button, IconButton, useTheme, Box, Autocomplete, FormControl, Select, MenuItem
} from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';

import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';


const SkillTable = ({ dataSkillDetails, setDataSkillDetails, idEmployee }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [dataSkill, setDataSkill] = useState([]);

  const [dataSkillLevel, setDataSkillLevel] = useState([]);
  // const [dataSkillDetails, setDataSkillDetails] = useState([]);

  useEffect(() => {
    if (!isDataLoaded) {
      const para = { p_employee_id: idEmployee, p_selected_mode: '' };
      callApi(API_ENDPOINTS.HR_EMPLOYEE_SKILLS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setDataSkillDetails(data);
          }
        })
        .catch(error => console.error('Error fetching Skill:', error));
    }
  }, [isDataLoaded, idEmployee]);

  useEffect(() => {
    if (!isDataLoaded) {
      const para = { p_employee_id: idEmployee, p_selected_mode: 'all' };
      callApi(API_ENDPOINTS.HR_EMPLOYEE_SKILLS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setDataSkill(data);
          }
        })
        .catch(error => console.error('Error fetching Skill:', error));
    }
  }, [isDataLoaded]);

  useEffect(() => {
    if (!isDataLoaded) {
      const para = { p_companyid: localStorage.getItem('companyid'), };
      callApi(API_ENDPOINTS.HR_EMPLOYEE_SKILL_LEVEL_MASTER_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setDataSkillLevel(data);
          }
        })
        .catch(error => console.error('Error fetching Skill:', error));
    }
  }, [isDataLoaded]);




  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const updatedContacts = [...dataSkillDetails];
    updatedContacts[index][name] = value;
    setDataSkillDetails(updatedContacts);
  };


  const handleAutocompleteChange = (index, name, value, name1, id) => {
    setDataSkillDetails(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [name]: value, // updates skill_name or whatever
        [name1]: id
      };
      return updated;
    });
  };




  const addContact = () => {
    setDataSkillDetails([...dataSkillDetails, {
      id: '',
      skill_name: null,
      skill_level: '',
      year_of_experiance: '',
      certification_name: '',
      certification_expiry: '',
      id_skill: '',
      id_skill_level: '',
      skill_level_name: '',

    }]);
  };



  const removeContact = (index) => {
    const updatedContacts = dataSkillDetails.filter((_, i) => i !== index);
    setDataSkillDetails(updatedContacts);
  };


  return (
    <Box
      gridColumn="span 9"
      gridRow={"span 2"}
      alignItems="center"
      justifyContent="center"
      // padding={1}
      sx={{
        "& .MuiTable-root": { border: "none", size: "small" },
        "& .MuiTableCell-root": {
          borderBottom: "none",
          border: "1px solid",
          borderColor: `${colors.primary[400]} !important`,
        },
        "& .name-column--cell": { color: colors.greenAccent[300] },
        "& .MuiTableHead-root": { borderBottom: "none" },
        "& .MuiTableBody-root": { overflowY: "auto" },
        "& .MuiCheckbox-root": {
          color: `${colors.blueAccent[200]} !important`,
          size: "small",
        },
        "& .MuiTableFooter-root": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
          height: "10px",
        },
        "& .MuiButton-text": { color: `${colors.grey[100]} !important` },
      }}
    >
      <TableContainer >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', width: '10px' }}>Skill Name</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Skill Level</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Year Of Experience</TableCell>
              <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Certification Name</TableCell>
              {/* <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Certification Expiry</TableCell> */}

              {/* <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>Mobile</TableCell>
                    <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', width:'200px'  }}>Designation</TableCell>
                    <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px', width:'200px' }}>Department</TableCell> */}

              <TableCell style={{ size: "small", border: '1px solid transparent', fontSize: '14px' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(dataSkillDetails) && dataSkillDetails.length > 0 &&
              dataSkillDetails.map((skill, index) => {
                const selectedSkill = dataSkill.find(d => d.id_skill === skill.id_skill) ||
                  (skill.skill_name ? { skill_name: skill.skill_name, id_skill: null } : null);

                const selectedSkillLevel = dataSkillLevel.find(d => d.id_skill_level === skill.id_skill_level) || null;

                return (
                  <TableRow key={index}>
                    <TableCell style={{ minWidth: 250, whiteSpace: "nowrap", size: "small", border: '1px solid black', fontSize: '14px' }}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        freeSolo
                        value={typeof selectedSkill === 'string' ? { skill_name: selectedSkill } : selectedSkill}
                        onChange={(event, newValue) => {
                          if (typeof newValue === 'string') {
                            handleAutocompleteChange(index, "skill_name", newValue, "id_skill", null);
                          } else if (newValue && newValue.inputValue) {
                            handleAutocompleteChange(index, "skill_name", newValue.inputValue, "id_skill", null);
                          } else {
                            handleAutocompleteChange(
                              index,
                              "skill_name",
                              newValue?.skill_name || '',
                              "id_skill",
                              newValue?.id_skill || null
                            );
                          }
                        }}
                        filterOptions={(options, params) => {
                          const filtered = options.filter(option =>
                            option.skill_name?.toLowerCase().includes(params.inputValue.toLowerCase())
                          );

                          if (
                            params.inputValue !== '' &&
                            !options.some(option => option.skill_name.toLowerCase() === params.inputValue.toLowerCase())
                          ) {
                            filtered.push({
                              inputValue: params.inputValue,
                              skill_name: `Add "${params.inputValue}"`,
                              id_skill: null
                            });
                          }

                          return filtered;
                        }}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        options={dataSkill || []}
                        getOptionLabel={(option) => {
                          if (typeof option === 'string') return option;
                          if (option.inputValue) return option.inputValue;
                          return option.skill_name || '';
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              sx: {
                                '& .MuiOutlinedInput-notchedOutline': {
                                  border: 'none',
                                },
                                paddingY: 0,
                                backgroundColor: 'transparent',
                              },
                            }}
                          />
                        )}
                      />

                    </TableCell>

                    <TableCell style={{ minWidth: 200, size: "small", border: '1px solid black', fontSize: '14px' }}>
                      {/* <TextField
                        name="skill_level"
                        value={skill.skill_level}
                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                        onChange={(e) => handleInputChange(index, e)}
                      /> */}

                      <Autocomplete
                        size="small"
                        fullWidth
                        // freeSolo
                        value={selectedSkillLevel}
                        onChange={(event, newValue) =>
                          handleAutocompleteChange(index, "skill_level_name", newValue?.skill_level_name || '', "id_skill_level", newValue?.id_skill_level || null)
                        }
                        options={dataSkillLevel || []}
                        getOptionLabel={(option) => option.skill_level_name || ''}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              sx: {
                                '& .MuiOutlinedInput-notchedOutline': {
                                  border: 'none',
                                },
                                paddingY: 0,
                                backgroundColor: 'transparent',
                              },
                            }}
                          />
                        )}
                      />
                    </TableCell>

                    <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                      <TextField
                        name="year_of_experiance"
                        value={skill.year_of_experiance}
                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                    </TableCell>


                    <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                      <TextField
                        name="certification_name"
                        value={skill.certification_name}
                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none' } } }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                    </TableCell>


                    <TableCell style={{ size: "small", border: '1px solid black', fontSize: '14px' }}>
                      <IconButton onClick={() => removeContact(index)}>
                        <HighlightOffOutlinedIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}



            <TableRow>
              <TableCell colSpan={9}>
                <Button
                  sx={{ textTransform: 'none' }}
                  onClick={addContact}
                  variant="standard"
                  color="secondary"
                  startIcon={<AddIcon sx={{ color: colors.blueAccent[500] }} />}
                >
                  Add Skills
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SkillTable;



